import { render } from "./Order-list.vue?vue&type=template&id=05944142&scoped=true"
import script from "./Order-list.vue?vue&type=script&lang=js"
export * from "./Order-list.vue?vue&type=script&lang=js"

import "./Order-list.vue?vue&type=style&index=0&id=05944142&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05944142"]])

export default __exports__